/**
 * FloatingActionMenu.tsx
 * 카카오톡 상담 플로팅 버튼 (단일 버튼)
 */

import { Box, Fab, useMediaQuery, useTheme } from '@mui/material';
import { keyframes } from '@mui/system';

const KAKAO_CHANNEL_URL = 'https://pf.kakao.com/_QXtCxj/chat';
const KAKAO_YELLOW = '#FEE500';
const KAKAO_BROWN = '#3C1E1E';

const bounceIn = keyframes`
  0% { transform: scale(0); opacity: 0; }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); opacity: 1; }
`;

const pulse = keyframes`
  0%, 100% { box-shadow: 0 4px 16px rgba(254, 229, 0, 0.3); }
  50% { box-shadow: 0 6px 24px rgba(254, 229, 0, 0.5); }
`;

const KakaoTalkIcon = ({ size = 24 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C6.477 3 2 6.463 2 10.691c0 2.678 1.782 5.038 4.465 6.385l-.637 3.118a.3.3 0 0 0 .454.324l3.747-2.454c.64.094 1.299.145 1.971.145 5.523 0 10-3.463 10-7.518C22 6.463 17.523 3 12 3Z"
      fill={KAKAO_BROWN}
    />
  </svg>
);

export default function FloatingActionMenu() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const buttonSize = isMobile ? 52 : 60;

  const handleClick = () => {
    window.open(KAKAO_CHANNEL_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: isMobile ? 20 : 24,
        right: isMobile ? 20 : 24,
        zIndex: 9999,
      }}
    >
      <Fab
        onClick={handleClick}
        aria-label="카카오톡 상담"
        sx={{
          width: buttonSize,
          height: buttonSize,
          backgroundColor: KAKAO_YELLOW,
          color: KAKAO_BROWN,
          boxShadow: '0 4px 16px rgba(254, 229, 0, 0.3)',
          animation: `${bounceIn} 0.5s ease-out, ${pulse} 3s ease-in-out infinite 1s`,
          transition: 'all 0.2s ease',
          '&:hover': {
            backgroundColor: '#FDD835',
            transform: 'scale(1.08)',
            boxShadow: '0 6px 20px rgba(254, 229, 0, 0.5)',
          },
          '&:active': {
            transform: 'scale(0.95)',
          },
        }}
      >
        <KakaoTalkIcon size={isMobile ? 26 : 30} />
      </Fab>
    </Box>
  );
}
